import React, { useState } from 'react'

const Footer = () => {

  const LEGAL_CONTENT = {
    impressum: (
      <div className="space-y-4 text-slate-600 text-sm text-left">
        <p><strong>Angaben gemäß § 5 DDG</strong></p>
        <p>Mesmin N. Fonzong<br />Mesmin Vision Digital Services<br />Am Cleefkothen 30<br />42117 wuppertal<br />Deutschland</p>
        <p><strong>Kontakt:</strong><br />Telefon: +49 (0) 15776500475<br />E-Mail: info@mesminvisionds.de</p>
        <p><strong>Umsatzsteuer</strong><br />Kleinunternehmer gemäß § 19 UStG. Es wird keine Umsatzsteuer ausgewiesen.</p>
        <p><strong>Verbraucherstreitbeilegung</strong><br />Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren
        vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
      </div>
    )
  };

  const [activeModal, setActiveModal] = useState(null);

  const socialLinks = [
    { name: 'WhatsApp', icon: 'wa', url: 'https://wa.me/4915776500475', color: '#25D366' },
    { name: 'Facebook', icon: 'fb', url: 'https://www.facebook.com/mesminvisiondigitalservices', color: '#1877F2' },
    { name: 'LinkedIn', icon: 'in', url: 'https://linkedin.com/in/votre_profil', color: '#0A66C2' },
    { name: 'Instagram', icon: 'ig', url: 'https://www.instagram.com/mesmin639', color: '#E1306C' }
  ];

  const currentHour = new Date().getHours();
  const isOnline = currentHour >= 8 && currentHour < 18; // Online de 8h à 17h59
  
  return (
    <footer className="relative bg-[#f8faff] pt-24 pb-12 border-t border-slate-100 z-0">
      
      {/* Animation de lueur discrète en arrière-plan */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-primary/5 rounded-full blur-[100px] pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          
          {/* 1. Branding & Slogan (Écrits normaux et pro) */}
          <div className="md:col-span-5 space-y-6">
            <h3 className="text-3xl font-black text-secondary tracking-tight">
              Mesmin<span className="text-primary">Vision</span>
            </h3>
            <p className="text-slate-600 text-lg leading-relaxed max-w-sm">
              Wir begleiten Unternehmen bei der digitalen Transformation durch 
              <span className="font-bold text-secondary"> ergebnisorientiertes Webdesign </span> 
              und nachhaltige Strategien.
            </p>
            {/* Icônes Sociales avec Interaction Douce */}
            <div className="flex gap-4 pt-4">
              {socialLinks.map((social) => (
                <a 
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-xl bg-white shadow-sm flex items-center justify-center text-slate-400 transition-all duration-300 hover:text-white hover:shadow-lg"
                  style={{ '--hover-bg': social.color }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = social.color}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                >
                  <span className="font-black uppercase text-xs">{social.icon}</span>
                </a>
              ))}
            </div>
          </div>

          {/* 2. Navigation Juridique (Écrits normaux) */}
          <div className="md:col-span-3 space-y-6">
            <h4 className="text-secondary font-bold text-lg">Rechtliches</h4>
            <ul className="space-y-4">
              <li>
                <button onClick={() => setActiveModal('impressum')} className="text-slate-500 hover:text-primary transition-colors text-base">
                  Impressum
                </button>
              </li>
              <li>
                {/* Redirection directe vers le PDF de la Datenschutzerklärung */}
                <a 
                  href="/datenschutzerklaerung.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-slate-500 hover:text-primary transition-colors text-base inline-block"
                >
                  Datenschutzerklärung
                </a>
              </li>
              <li>
                {/* Redirection directe vers le PDF des AGB (anciennement DSGVO-Konformität) */}
                <a 
                  href="/AGB.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-slate-500 hover:text-primary transition-colors text-base whitespace-nowrap inline-block"
                >
                  AGB
                </a>
              </li>
            </ul>
          </div>

          {/* 3. Expertise (Mots-clés stratégiques) */}
          <div className="md:col-span-4 space-y-6">
            <h4 className="text-secondary font-bold text-lg">Expertise</h4>
            <p className="text-slate-500 text-sm leading-relaxed">
              Spezialisiert auf <span className="text-secondary font-semibold">nutzerzentrierte Entwicklung</span> und 
              kontinuierliche <span className="text-secondary font-semibold">Konversionsoptimierung</span> für 
              maximale digitale Performance.
            </p>
            <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border transition-colors duration-500 ${
              isOnline 
                ? "bg-green-50 border-green-100" 
                : "bg-red-50 border-red-100"
            }`}>
              {/* Point lumineux avec animation pulse uniquement si Online */}
              <span className={`w-2 h-2 rounded-full transition-colors duration-500 ${
                isOnline 
                  ? "bg-green-500 animate-pulse" 
                  : "bg-red-500"
              }`}></span>
              
              <span className={`text-[11px] font-bold uppercase tracking-wider transition-colors duration-500 ${
                isOnline 
                  ? "text-green-700" 
                  : "text-red-700"
              }`}>
                Status: {isOnline ? "Online" : "Offline"}
              </span>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="mt-20 pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4 px-4 mb-28 md:mb-8">
          <p className="text-slate-400 text-[10px] md:text-xs text-center md:text-left">
            © 2026 Mesmin Vision Digital Services. Alle Rechte vorbehalten.
          </p>
          
          <p className="text-slate-400 text-[10px] md:text-xs font-medium text-center md:text-right">
            Entwickelt mit Präzision in Wuppertal.
          </p>
        </div>
      </div>

      {/* --- MODALE PROFESSIONNELLE (Uniquement pour l'Impressum) --- */}
      {activeModal && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center p-4 sm:p-6 animate-fadeIn">
          {/* Overlay */}
          <div className="absolute inset-0 bg-secondary/40 backdrop-blur-sm" onClick={() => setActiveModal(null)}></div>
          
          {/* Conteneur de la Pop-up */}
          <div className="relative w-full max-w-2xl bg-white rounded-[2.5rem] p-8 md:p-12 shadow-2xl border border-white transform animate-popIn max-h-[85vh] overflow-y-auto custom-scrollbar">
            
            <div className="flex justify-between items-center mb-8 border-b border-slate-100 pb-6">
              <h2 className="text-2xl font-black text-secondary uppercase tracking-tight">
                Impressum
              </h2>
              <button 
                onClick={() => setActiveModal(null)} 
                className="w-10 h-10 flex items-center justify-center bg-slate-50 rounded-full hover:bg-primary hover:text-white transition-all duration-300"
              >
                ✕
              </button>
            </div>
            
            {/* Affichage du contenu de l'Impressum */}
            <div className="pb-4">
              {LEGAL_CONTENT.impressum}
            </div>

            <button 
              onClick={() => setActiveModal(null)}
              className="mt-8 w-full py-4 bg-secondary text-white font-black uppercase text-xs tracking-[0.2em] rounded-2xl hover:bg-primary transition-all shadow-lg shadow-secondary/10"
            >
              Schließen
            </button>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;